var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoNftSmall = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.885 15.497a.5.5 0 0 1 .254-.436l16.106-9.085a.5.5 0 0 1 .49 0l16.106 9.085a.5.5 0 0 1 .255.436v19.007a.5.5 0 0 1-.255.436l-16.105 9.085a.5.5 0 0 1-.491 0L5.139 34.94a.5.5 0 0 1-.254-.436V15.497Z",
    fill: "#1D1A15",
    stroke: "#2B2A28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.932 30.816c-.803 0-1.486-.219-2.051-.655-.565-.44-.996-1.078-1.294-1.913-.299-.838-.448-1.85-.448-3.036 0-1.179.15-2.186.448-3.02.301-.838.735-1.478 1.3-1.918.567-.444 1.25-.666 2.045-.666.795 0 1.475.222 2.04.666.568.44 1.001 1.08 1.3 1.918.301.834.452 1.841.452 3.02 0 1.186-.149 2.198-.447 3.036-.299.835-.73 1.472-1.295 1.912-.564.437-1.248.656-2.05.656Zm0-1.172c.795 0 1.413-.384 1.853-1.15.44-.768.66-1.862.66-3.282 0-.945-.1-1.749-.303-2.413-.199-.664-.486-1.17-.863-1.518a1.904 1.904 0 0 0-1.347-.522c-.789 0-1.405.389-1.849 1.166-.444.774-.665 1.87-.665 3.287 0 .945.099 1.747.298 2.408.199.66.485 1.163.857 1.507.377.345.83.517 1.359.517Z",
    fill: "#A9A8A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 13.386c0-.54.29-1.038.758-1.304L20.75.997a1.5 1.5 0 0 1 1.483 0l19.491 11.085a1.5 1.5 0 0 1 .759 1.304v23.228a1.5 1.5 0 0 1-.759 1.304L22.233 49.003a1.5 1.5 0 0 1-1.483 0L1.258 37.918A1.5 1.5 0 0 1 .5 36.614V13.386Z",
    stroke: "#2B2A28"
  })));
};
export default SvgNoNftSmall;